import { IconButton } from "@mui/material";
import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { greyMui } from "@ryde/theme";

const HEADER_LOGO_HEIGHT_PX = 32;
const HEADER_LOGO_MAX_WIDTH_PX = 160;

export const HeaderTopUserActionsHistoryButtonStyled = styled(
  IconButton,
).attrs<IStyledAttributes>({
  "data-e2e": "header-user-actions-history",
})`
  color: ${greyMui._500};

  &:hover {
    color: ${greyMui._700};
    background-color: ${greyMui._100};
  }

  &:focus-visible {
    outline: 2px solid ${greyMui._500};
    outline-offset: 2px;
  }

  .MuiSvgIcon-root {
    color: inherit;
  }
`;

export const HeaderTopRightStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "header-top-right",
})`
  margin-inline-start: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;

  .header-top-right__user-actions-history {
    margin-inline-end: 4px;
  }

  .header-top-right__company {
    border-inline-start: 1px solid ${greyMui._300};
    padding-inline-start: 20px;
    margin-inline-start: 16px;
    margin-inline-end: 16px;
    display: flex;
    gap: 20px;
  }

  .header-top-right__company-name {
    max-width: 20ch;
    font-size: 12px;
    font-weight: bold;
    display: inline-flex;
    align-items: center;
    overflow-wrap: anywhere;
  }

  .header-top-right__nav-logo {
    display: inline-flex;
    align-items: center;
    height: ${HEADER_LOGO_HEIGHT_PX}px;

    .header-top-right__logo-image {
      max-height: 100%;
      width: auto;
      max-width: ${HEADER_LOGO_MAX_WIDTH_PX}px;
      object-fit: contain;
    }
  }
`;

export const HeaderTopTitleStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "header-top-title",
})`
  display: flex;
  align-items: center;
  margin-inline-start: 26px;
  h1 {
    font-size: 20px;
    font-weight: 500;
    margin: 0;
    color: ${greyMui._900};
  }
`;
